import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import Menu from '../icons/Menu';
import Tabmenu from './tabmenu/Tabmenu';
export default function AddMedicationManual() {
  let  [amount,setAmount]= useState(1);
  let  [duration,setDuration]= useState(2);
  let  [time,setTime]= useState('08:00:00');
  
  let h = window.innerHeight;
  let contentH = h-72;
  return (
    <>
      <div className=" bg-gray-50 " style={{height:h+'px'}}>

        <div className='flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50'>
          <div>
          <Link to="/AddMedication">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            </Link>
          </div>
          <div className='pl-2 flex-1 mt-0.5'>
            <h4 className='font-semibold text-sm'>Add Medication</h4>
          </div>
        </div>
        <div className='h-20'></div>

        <div className='flex justify-between flex-col p-4 overflow-y-scroll bg-gray-50'  style={{height:contentH+'px'}}>
          <div className='overflow-scroll hideScroll flex-1'>
            <div className='text-lg font-medium mb-4'>Add your medication <br /> below</div>
            <h5>Medicine form</h5>
            <div className='overflow-y-scroll hideScroll -mx-4'>
              <div className='grid grid-cols-4 w-96 gap-3 mt-2 pl-4'>
                <button className=' text-center'>
                  <div className=' bg-yellow-50 hover:bg-blue-200 p-5 rounded-3xl flex items-center justify-center h-20'>
                  <img src="../../../images/capsules.png" className=""/>
                  </div>   
                  Capsule               
                </button>
                <button className=' text-center'>
                  <div className=' bg-gray-100 hover:bg-blue-200 p-7 rounded-3xl flex items-center justify-center h-20'>
                  <img src="../../../images/bottlemed.png" className=" mx-2 -full "/>
                  </div>   
                  Solution               
                </button>
                <button className=' text-center'>
                  <div className=' bg-yellow-50 hover:bg-blue-200 p-7 rounded-3xl flex items-center justify-center h-20'>
                  <img src="../../../images/inhaler.png" className=" mx-2 h-12"/>
                  </div>   
                  Inhaler               
                </button>
                <button className=' text-center'>
                  <div className=' bg-red-50 hover:bg-blue-200 p-7 rounded-3xl flex items-center justify-center h-20'>
                  <img src="../../../images/syrinch.png" className=" "/>
                  </div>   
                  Insulin               
                </button>
              </div>              
            </div>
            <h5 className='mt-4 mb-2'>Capsule Name</h5>
            <div className="flex bg-gray-100 rounded-xl my-2 overflow-hidden">
                <input type="text" className="bg-gray-100 p-2 flex-1" placeholder="Full name"/>
                <img src="../../../images/cam.svg" className="m-2"/>
            </div>
            <div className='grid grid-cols-2 gap-4'>
              <div>
                <h5 className='mt-4 mb-2'>Amount</h5>
                <div className="flex bg-gray-200 rounded-xl my-2 overflow-hidden">
                    <input type="number" className="bg-transparent p-2 w-2/3" name="" placeholder="Full name" value={amount} onChange={(e)=>setAmount(e.target.value)}/>
                    <div className=' p-2 text-sm'>Pills</div>
                </div>                
              </div>
              <div>
                <h5 className='mt-4 mb-2'>How long?</h5>
                <div className="flex bg-gray-200 rounded-xl my-2 relative overflow-hidden">
                  <input type="text" className="bg-transparent p-2 w-1/2"  value={duration} onChange={(e)=>setDuration(e.target.value)}/>
                  <select className="bg-transparent p-2 w-1/2 text-sm">
                    <option>Days</option>
                    <option selected>Weeks</option>
                    <option>Months</option>
                  </select>
                </div>
              </div>
            </div>
            <h5 className='mt-4 mb-2'>Time 1</h5>
            <div className="flex bg-gray-200 rounded-2xl  overflow-hidden input">
                <img src="../../../images/bell2.svg" className="m-2"/>
                <div className='input-container flex-1'>
                  <input type="time" className="bg-gray-200 p-2 flex-1 text-center" value={time} onChange={(e)=>setTime(e.target.value)}/>
                </div>
                
                <button className='px-2 h-8 w-8 m-2 mr-1 bg-green-300  rounded-full text-lg'>+</button>
            </div>    
          </div>
      
          <div>
          <Link to="/Dashboard" className=' text-center w-full rounded-2xl bg-blue-100 text-primary my-4 font-medium border-blue-300
           border p-3 pt-4 text-white block'>Add description</Link>
          <Link to="/Medication" className=' text-center w-full rounded-2xl bg-primary border-primary p-3 pt-4 text-white block'>Done</Link>
          </div>
          

        </div>
        </div>
      {/* <Tabmenu /> */}
    </>
  );
}